import { Button, Icon } from '@mui/material';
import { Styled } from './index.styles';
import { routesPaths } from 'config/routes';
import { NumberFormatInt } from 'common/utils';
import i18n from 'assets/i18n';
import 'moment/locale/tr';
import moment from 'moment';
import { mediaBreakPoints, useMediaScreen } from 'common/theme/media';

interface data {
    type: 'primary' | 'secondary';
    item: any;
    index: any;
    logoHidden?: boolean;
    urlCompany?: boolean;
}

const BusPopularBox = (props: data) => {
    const item = props.item;
    const media = useMediaScreen();

    const nowDate = moment(new Date()).format('YYYYMMDD');
    let url = `${routesPaths[i18n.language].bus}/${item.FromCode}/${item.ToCode}/${nowDate}`;
    let urlCompany = `${routesPaths[i18n.language].bus}/${item.FromCode}/${item.ToCode}/${nowDate}/${item.CompanyCode}`;
    return (
        <Styled className="overflow-hidden" key={props.index}>
            {mediaBreakPoints.xltablet < media.width ? (
                <Button href={urlCompany ? urlCompany : url} className={`ticket ${props.type}`}>
                    <div className={`left ${props.logoHidden ? 'logo-hidden' : ''}`}>
                        <img
                            src={`https://cdn.enucuzu.com/buslines/${item.CompanyCode}.png`}
                            height={24}
                            width={100}
                            style={{
                                objectFit: 'contain',
                                objectPosition: ' center',
                            }}
                        />
                    </div>
                    <div className="right">
                        <div className="from-to">
                            <span>{item.FromName}</span>
                            <Icon>{item.ReturnDay ? 'swap_horiz' : 'arrow_forward'}</Icon>
                            <span>{item.ToName}</span>
                        </div>
                        <div className="detail">
                            <div className="price">
                                {NumberFormatInt(item.Price)}
                                <small>
                                    <Icon>currency_lira</Icon>
                                </small>
                            </div>
                            <div className="arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                        </div>
                    </div>
                </Button>
            ) : (
                <Button href={url} className={`ticket ${props.type}`}>
                    <div className="up">
                        <div className="from-to">
                            <span>{item.FromName}</span>
                            <Icon>{item.ReturnDay ? 'swap_horiz' : 'arrow_forward'}</Icon>
                            <span>{item.ToName}</span>
                        </div>
                    </div>
                    <div className={`down`}>
                        {!props.logoHidden && (
                            <img
                                src={`https://cdn.enucuzu.com/buslines/${item.CompanyCode}.png`}
                                height={24}
                                width={120}
                                style={{
                                    objectFit: 'contain',
                                    objectPosition: 'left center',
                                }}
                            />
                        )}

                        <div className={`detail ${props.logoHidden ? 'logo-hidden' : ''}`}>
                            <div className="price">
                                {NumberFormatInt(item.Price)}
                                <small>
                                    <Icon>currency_lira</Icon>
                                </small>
                            </div>
                            <div className="arrow">
                                <Icon>arrow_forward</Icon>
                            </div>
                        </div>
                    </div>
                </Button>
            )}
        </Styled>
    );
};

export default BusPopularBox;
